import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetAllRoles(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminGetAllRolesAttempt', handleGetAllRoles, api);
}

function* handleGetAllRoles(api: AdminGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getAllRoles], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminGetAllRolesFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.adminGetAllRolesSuccess(response.data));
    }
}
